module.exports = __webpack_public_path__ + "img/customerfaces1.016fcea8.png";